import { functionnal } from "vincent-utils";
import _ from "underts";
import areInCollision from "../rdvs/collision.js";
const replaceRdvWithEmpty = (rdv, duration) => ({
    date: rdv.date,
    hour: rdv.hour,
    minute: rdv.minute,
    duration,
    patient: null,
    tag: "empty",
});
//met des cases vides avec des stars là où il y a des candidats -> ces cases étaient occupées par des fakes
const emptyCandidatesCases = (dayRdvs, dayCandidates, duréeMini) => {
    return dayRdvs.map((rdv) => dayCandidates.some(functionnal.curry2(areInCollision)(rdv))
        ? starCandidatesCases(rdv, dayCandidates, duréeMini)
        : rdv);
};
export const isFakeCase = (rdv) => {
    return rdv.tag === "fake";
};
const starCandidatesCases = (rdv, dayCandidates, dureeMini) => {
    //la case correspond à l'heure précise du candidat
    const candidate = dayCandidates.find((cand) => cand.hour === rdv.hour && cand.minute === rdv.minute);
    //la case ne correspond pas à l'heure précise du candidat
    //mais elle est dans la plage horaire du candidat donc on met une case vide à la place du fake
    if (!candidate) {
        return replaceRdvWithEmpty(rdv, dureeMini);
    }
    // if (!isFakeCase(rdv)) {
    //   throw new Error(
    //     "rdv found is not fake in markCandidatesCases " +
    //       JSON.stringify(rdv, null, 2) +
    //       "candidate " +
    //       JSON.stringify(candidate, null, 2)
    //   );
    // }
    return {
        ...replaceRdvWithEmpty(rdv, dureeMini),
        stars: Math.floor(candidate.score / 5),
    };
};
const openCandidateCasesForDays = (dayRdvs, dayCandidates, dureeMini) => {
    return emptyCandidatesCases(dayRdvs, dayCandidates, dureeMini);
};
const haveSameDate = (rdv1, rdv2) => rdv1 && rdv2 && rdv1.date.getTime() === rdv2.date.getTime();
const daysAreSame = (dayRdvs1, dayRdvs2) => {
    const firstRdv1 = _.first(dayRdvs1);
    const firstRdv2 = _.first(dayRdvs2);
    if (!firstRdv1 || !firstRdv2) {
        return false;
    }
    return haveSameDate(firstRdv1, firstRdv2);
};
const match = (weekRdvs1, weekRdvs2) => {
    return weekRdvs1.reduce((result, dayRdvs) => {
        const index = weekRdvs2.findIndex((dayRdvs2) => daysAreSame(dayRdvs, dayRdvs2));
        if (index !== -1) {
            return [...result, [dayRdvs, weekRdvs2[index]]];
        }
        else {
            return [...result, [dayRdvs, []]];
        }
    }, []);
};
const openCandidateCasesForWeeks = (weekRdvs, weekCandidates, duréeMini) => {
    return match(weekRdvs, weekCandidates).map(([dayRdvs, dayCandidates]) => openCandidateCasesForDays(dayRdvs, dayCandidates, duréeMini));
};
const test = {
    match,
};
export { emptyCandidatesCases, starCandidatesCases, openCandidateCasesForWeeks, test, };
//# sourceMappingURL=openCandidateCases.js.map